import DiscordWidget from './DiscordWidget'

function HeroSection() {
  return (
    <section id="home" className="ac-hero ac-width">
      <div className="ac-hero-copy">
        <h1>Hrajeme,<br /><span>když je nálada.</span></h1>
        <p>Hry, povídání a parta na Discordu. Jsme Allcom, česká komunita od Evobugu.</p>
        <div className="ac-hero-actions">
          <a href="https://discord.allcom.zone" className="ac-button" target="_blank" rel="noopener noreferrer">
            Připojit se na Discord
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
          </a>
          <a href="#about" className="ac-text-link">Poznat Allcom</a>
        </div>
      </div>
      <DiscordWidget />
      <div className="ac-hero-index">
        <a href="#community"><strong>Hry & povídání</strong><span>Když se sejdeme.</span></a>
        <a href="#events"><strong>Společné akce</strong><span>Plán je na Discordu.</span></a>
        <a href="#about"><strong>I mimo obrazovku</strong><span>Občas se potkáme naživo.</span></a>
      </div>
    </section>
  )
}

export default HeroSection
